import React, { Suspense } from 'react'
import registeredComponent from '../../utils/registeredComponent';

const FontAwesomeHelper = ({ iconFamily, iconName, userClass }) => {
  let FontIcon = null

  if (iconFamily === 'light') {
    FontIcon = React.lazy(() => import('./FontAwesomeLight'))
  }
  if (iconFamily === 'solid') {
    FontIcon = React.lazy(() => import('./FontAwesomeSolid'))
  }
  if (iconFamily === 'regular') {
    FontIcon = React.lazy(() => import('./FontAwesomeRegular'))
  }
  return (
    <div className={userClass}>
      <Suspense fallback={<div>...</div>}>
        <FontIcon iconName={iconName} />
      </Suspense>
    </div>
  )
}

export default registeredComponent("FontAwesomeHelper")(FontAwesomeHelper);
